import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './auth'
import Role from './role'
import Path from './path'
import Meta from './meta'
import Backurl from './backurl'
import Source from './source'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    Auth,
    Role,
    Path,
    Meta,
    Backurl,
    Source
  }
})

export default store
